import gql from "graphql-tag";

export const typeDefs = gql`
  extend type Query {
    facilityId: Int!
    clientId: Int!
  }`


export const resolvers = {};